import * as React from 'react';
import './index.scss';
import { fetch, RankItem, RichRankRsp } from '@pubts/fetch.ts';
import { None, WebAnchorItem, WithPage, WebAnchorItemDesc } from '@huyafed/comp'
interface Props {
  data: RichRankRsp
}
const { useState, useEffect } = React;

const Rich: React.FC<Props> = props => (
  <div className='rich' id='rich'>
    <i className={`rank-rich-`} />
    <WebAnchorItemDesc
      width={860}
      color="#f6d94a"
      descs={['排名', '神豪昵称', '总里程']}
    />
    <div className='rich-List'>
      {
        props.data.length === 0 ?
          <None text={'暂无数据'} />
          :
          props.data.map((item: RankItem, idx: number) => (
            <WebAnchorItem
              width={870}
              canJump={false}
              isLarge={true}
              color={'#ffffff'}
              borderColor={'#0f257e'}
              key={idx}
              msg={{ ...item, tJump: { ...item.tJump, bIsLive: item.tJump.iIsLive }, sNickName: item.sNickName, sLogoUrl: item.sLogoUrl }}
            />
          ))
      }
      {props.children}
    </div>
  </div>
)
export default WithPage(Rich);